import controller from './blog-detail.controller';
import templateBase from './templates/blog-detail-base.view.html';
import templateT1 from './templates/blog-detail-t1.view.html';
import templateAD from './templates/blog-detail-adaptative.html';

let BlogDetailComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
    if(__env.adaptative) {
        return templateAD;
    } else { 
        if(response.BLOG_DETAIL !== undefined && response.BLOG_DETAIL.component == 'template_t1') {
            return templateT1
        }
        else {
            return templateBase;
        }
    }
}

export default BlogDetailComponent;


/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/blog/blog-detail/blog-detail.component.js
 **/